import RestResource from '../rest.service';

export default class CropsService extends RestResource {
  map(payload) {
    return {
      name: payload.name,
      unit: payload.unit,
      for_sale: payload.forSale,
    };
  }

  constructor() {
    super('crops');
  }
}
